(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-periodo', {
            parent: 'entity',
            url: '/ss-periodo',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSPeriodos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-periodo/s-s-periodos.html',
                    controller: 'SSPeriodoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-periodo-detail', {
            parent: 'ss-periodo',
            url: '/ss-periodo/{id}',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSPeriodo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-detail.html',
                    controller: 'SSPeriodoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSPeriodo', function($stateParams, SSPeriodo) {
                    return SSPeriodo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-periodo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-periodo-detail.edit', {
            parent: 'ss-periodo-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-dialog.html',
                    controller: 'SSPeriodoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-periodo.new', {
            parent: 'ss-periodo',
            url: '/new',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-dialog.html',
                    controller: 'SSPeriodoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                iniPeriodo: null,
                                finPeriodo: null,
                                indiceAnual: null,
                                iniConvocatoria: null,
                                finConvocatoria: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-periodo', null, { reload: 'ss-periodo' });
                }, function() {
                    $state.go('ss-periodo');
                });
            }]
        })
        .state('ss-periodo.edit', {
            parent: 'ss-periodo',
            url: '/{id}/edit',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-dialog.html',
                    controller: 'SSPeriodoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-periodo', null, { reload: 'ss-periodo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-periodo.delete', {
            parent: 'ss-periodo',
            url: '/{id}/delete',
            data: {
            	authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-periodo/ss-periodo-delete-dialog.html',
                    controller: 'SSPeriodoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSPeriodo', function(SSPeriodo) {
                            return SSPeriodo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-periodo', null, { reload: 'ss-periodo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
